import React from 'react'
import { TWContentBlockFullWidth } from '../../../TWContentBlockFullWidth/TWContentBlockFullWidth'
import { IconBookOpen } from '../../../icons/IconBookOpen/IconBookOpen'

export function TWAppDownloadDigitalEditionBlock() {
    const imgSrc = require('../assets/editions-content-block-image.webp')

    return (
        <TWContentBlockFullWidth
            heading={'Access a daily Digital Edition of the newspaper'}
            subText={
                'Navigate through digital versions of the newspaper exactly as printed, ' +
                'with editions available for 2 weeks from publication, including The West Australian, ' +
                'The Sunday Times and all West regional publications in one convenient place.'
            }
            imgSrc={imgSrc}
            contentPosition={'right'}
            headingIntent={{
                headingIntentStartIndex: 2,
                headingIntentLength: 3,
            }}
            headerIcon={<IconBookOpen />}
            backgroundColor={'rgba(4, 61, 226, 0.06)'}
        />
    )
}
